import React from 'react';
import PriceChart from './PriceChart';
import { TrackedQuery } from '../hooks/usePriceTracker';

interface TrackerListProps {
  tracked: TrackedQuery[];
  onRemove: (id: string) => void;
  onSearch: (query: string) => void;
}

/** 검색어 기반 추적 목록 컴포넌트 */
export default function TrackerList({ tracked, onRemove, onSearch }: TrackerListProps) {
  if (tracked.length === 0) {
    return (
      <div className="tracker-empty">
        <p>추적 중인 검색어가 없습니다. 검색 후 "검색어 추적하기" 버튼을 눌러 추가하세요.</p>
      </div>
    );
  }

  return (
    <div className="tracker-list">
      {tracked.map((item) => {
        const firstPrice = item.priceHistory[0]?.price ?? 0;
        const diff = firstPrice > 0 ? item.currentLowest - firstPrice : 0;
        const diffPct = firstPrice > 0
          ? Math.round((diff / firstPrice) * 100) : 0;

        return (
          <div key={item.id} className="tracker-card">
            <div className="tracker-info">
              <h4 className="tracker-title">🔍 {item.query}</h4>
              <p className="tracker-mall">
                {item.currentProductTitle || '가격 조회 전'}
              </p>
              <div className="tracker-prices">
                {item.currentLowest > 0 ? (
                  <span className="tracker-current">
                    {item.currentLowest.toLocaleString()}원
                  </span>
                ) : (
                  <span className="tracker-current">—</span>
                )}
                {diff !== 0 && firstPrice > 0 && (
                  <span className={`tracker-diff ${diff < 0 ? 'down' : 'up'}`}>
                    {diff < 0 ? '▼' : '▲'} {Math.abs(diff).toLocaleString()}원
                    ({diffPct > 0 ? '+' : ''}{diffPct}%)
                  </span>
                )}
                {diff === 0 && firstPrice > 0 && (
                  <span className="tracker-diff same">변동 없음</span>
                )}
              </div>
              <p className="tracker-initial">
                등록일: {item.addedDate} · 이력 {item.priceHistory.length}건
              </p>
            </div>
            <PriceChart history={item.priceHistory} />
            <div className="tracker-actions">
              <button onClick={() => onSearch(item.query)} className="tracker-buy">
                검색하기
              </button>
              <button onClick={() => onRemove(item.id)} className="tracker-remove">
                삭제
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
